export default {
  start: {
    id: 0,
    bodyImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-sunny.jpg",
    roofImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-start-end.png",
    title: "La protección total para techos es más que profunda para tejas.",
    paragraph: "Elija la belleza que aparece con un sistema de techo completo.",
    ctaText: "VER EL SISTEMA DE TRES PARTES",
    ctaTarget: "seal"
  },
  seal: {
    id: 1,
    bodyImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-stormy.jpg",
    roofImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-seal.png",
    iconUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/seal.svg",
    title: "Ayuda a crear una barrera impermeable.",
    paragraph: "Bloquee el agua que se deriva de la acumulación de hielo, las lluvias impulsadas por el viento y el flujo normal de agua. Un techo debidamente sellado ayuda a prevenir la podredumbre y el moho.",
    ctaText: "POR QUÉ SELLAR",
    ctaTarget: "sealInner"
  },
  sealInner: {
    id: 2,
    bodyImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-stormy.jpg",
    roofImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-seal.png",
    backTarget: "seal",
    title: "Bloquee el agua que se deriva de la acumulación de hielo, las lluvias impulsadas por el viento y el flujo normal de agua.",
    paragraph: "Un techo debidamente sellado ayuda a prevenir la podredumbre y el moho.",
    innerPhotos: [
      {
        imageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/inner-photos/mold.jpg",
        title: "Moho"
      },
      {
        imageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/inner-photos/rot.jpg",
        title: "Pudrición"
      }
    ],
    ctaText: "POR QUÉ DEFENDER",
    ctaTarget: "defend"
  },
  defend: {
    id: 3,
    bodyImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-partly-cloudy.jpg",
    roofImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-defend.png",
    iconUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/defend.svg",
    title: "Ayuda a proteger contra los elementos climáticos.",
    paragraph: "Agregue una capa de defensa resistente, si bien hermosa, con una fuerte adhesión que resiste las explosiones y ayuda a eliminar el agua de la cubierta del techo. Ayuda a proteger las áreas más vulnerables, como aleros y picos.",
    ctaText: "POR QUÉ DEFENDER",
    ctaTarget: "defendInner"
  },
  defendInner: {
    id: 4,
    bodyImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-partly-cloudy.jpg",
    roofImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-defend.png",
    backTarget: "defend",
    title: "Agregue una capa de defensa resistente, si bien hermosa, con una fuerte adhesión que resiste las explosiones y ayuda a eliminar el agua de la cubierta del techo.",
    paragraph: "Ayuda a proteger las áreas más vulnerables, como aleros y picos.",
    innerPhotos: [
      {
        imageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/inner-photos/blow-off.jpg",
        title: "Soplar"
      },
      {
        imageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/inner-photos/impact.jpg",
        title: "Impacto"
      }
    ],
    ctaText: "POR QUÉ RESPIRAR",
    ctaTarget: "breathe"
  },
  breathe: {
    id: 5,
    bodyImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-sunny.jpg",
    roofImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-breathe.png",
    iconUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/breathe.svg",
    title: "Para una ventilación equilibrada del ático.",
    paragraph: "Reduzca la acumulación de calor y humedad que puede provocar la formación de presas de hielo, deterioro del tejado y aparición de moho. Esto ayuda a que el aire circule por el ático para controlar la temperatura y la humedad.",
    ctaText: "POR QUÉ RESPIRAR",
    ctaTarget: "breatheInner"
  },
  breatheInner: {
    id: 6,
    bodyImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-sunny.jpg",
    roofImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-breathe.png",
    backTarget: "breathe",
    title: "Reduzca la acumulación de calor y humedad que puede provocar la formación de presas de hielo, deterioro del tejado y aparición de moho.",
    paragraph: "Ayuda a que el aire circule por el ático para controlar la temperatura y la humedad.",
    innerPhotos: [
      {
        imageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/inner-photos/mold.jpg",
        title: "Moho"
      },
      {
        imageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/inner-photos/ice-damming.jpg",
        title: "Amortiguación por hielo"
      },
      {
        imageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/inner-photos/heat-buildup.jpg",
        title: "Acumulación de calor"
      }
    ],
    ctaText: "COMUNÍQUESE",
    ctaTarget: "end"
  },
  end: {
    id: 7,
    bodyImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-sunny.jpg",
    roofImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-start-end.png",
    title: "Comuníquese con nosotros hoy mismo para programar un estimado."
  }
} 